import { render, staticRenderFns } from "./CapacitanceReadings.vue?vue&type=template&id=2f22460b&"
import script from "./CapacitanceReadings.vue?vue&type=script&lang=js&"
export * from "./CapacitanceReadings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports